import { createSlice } from '@reduxjs/toolkit';
import { Slices } from 'ducks/slices';
import { CardInfo } from 'ducks/types/common-types';
import { Card } from 'ducks/types/prop-types';

export interface ModalsState {
  api_error: boolean;
  create_project: boolean;
  manage_parameter: boolean;
  manage_schedule_batch: boolean;
  stop_job: boolean;
  success: boolean;
  success_reset: boolean;
  run_job_definition: boolean;
  advanced_filtering: boolean;
  edit_job_extra: {
    vision: boolean;
    id: number | null;
    parent?: number | null;
    card_item?: Card | null;
  };
  edit_job_extra_view: boolean;
  parameter_connections: {
    vision: boolean;
    card_info: CardInfo;
  };
  parameter_connections_view: boolean;
  create_parameter: {
    vision: boolean;
    owner_id: number | null;
  };
  create_parameter_view: boolean;
  edit_batch_item: boolean;
  run_batch_definition: boolean;
  run_schedule_batch: boolean;
  schedule_batch_history: boolean;
  edit_job: boolean;
  create_job_definition: boolean;
  change_password: boolean;
  manage_user: boolean;
  warning: boolean;
}

const initialState: ModalsState = {
  api_error: false,
  create_project: false,
  manage_parameter: false,
  manage_schedule_batch: false,
  stop_job: false,
  success: false,
  success_reset: false,
  run_job_definition: false,
  advanced_filtering: false,
  edit_job_extra: {
    vision: false,
    id: null,
    parent: null,
    card_item: null,
  },
  edit_job_extra_view: false,
  parameter_connections: {
    vision: true,
    card_info: {
      current_params: [],
      children_params: [],
      batch_definition_item_id: null,
      children_item_ids: [],
      batch_definition_item_name: '',
    },
  },
  parameter_connections_view: false,
  create_parameter: {
    vision: false,
    owner_id: null,
  },
  create_parameter_view: false,
  edit_batch_item: false,
  run_batch_definition: false,
  run_schedule_batch: false,
  schedule_batch_history: false,
  edit_job: false,
  create_job_definition: false,
  change_password: false,
  manage_user: false,
  warning: false,
};

export const modalsSlice = createSlice({
  name: Slices.MODALS,
  initialState,
  reducers: {
    setModal: (state, action) => {
      return { ...state, ...action.payload };
    },
    openModal: (state, action) => {
      return { ...state, ...action.payload };
    },
    closeModal: (state, action) => {
      return { ...state, ...action.payload };
    },
    clearModals: () => {
      return initialState;
    },
  },
});

export const { setModal, clearModals } = modalsSlice.actions;

export default modalsSlice.reducer;
